export function createFundingSettings() {
  return {
    funding_enabled: false,
    slug: "",
    slug_locked: false,
    promotion_code: "",
    visibility: "private",
    display_order: 0,
    goal_amount_krw: 500000,
  }
}

export function campaignToFundingSettings(campaign) {
  if (!campaign) return createFundingSettings()

  return {
    ...createFundingSettings(),
    funding_enabled: Boolean(campaign.funding_enabled),
    slug: campaign.slug || "",
    slug_locked: Boolean(campaign.slug_locked || campaign.published_at),
    promotion_code: campaign.promotion_code || "",
    visibility: campaign.visibility === "public" ? "public" : "private",
    display_order: Number(campaign.display_order || 0),
    goal_amount_krw: Number(campaign.goal_amount_krw || 500000),
  }
}

export function fundingPayload(funding, conceptId) {
  const payload = {
    concept_id: Number(conceptId),
    funding_enabled: Boolean(funding.funding_enabled),
  }

  if (!funding.funding_enabled) return payload

  return {
    ...payload,
    slug: funding.slug.trim(),
    promotion_code: funding.promotion_code.trim(),
    visibility: funding.visibility,
    display_order: Number(funding.display_order || 0),
    goal_amount_krw: Number(funding.goal_amount_krw),
  }
}

export async function loadFundingSettings(http, conceptId) {
  try {
    const response = await http.get(`/api/admin/funding/projects/by-concept/${conceptId}`)
    return {
      exists: Boolean(response.data && response.data.campaign),
      funding: campaignToFundingSettings(response.data && response.data.campaign),
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { exists: false, funding: createFundingSettings() }
    }
    throw error
  }
}

export async function saveFundingSettings(http, conceptId, funding) {
  return http.put(
    `/api/admin/funding/projects/by-concept/${conceptId}`,
    fundingPayload(funding, conceptId)
  )
}
